import {
  CodeActions,
  CodeActionsProps,
  PreviewJson as DsPreviewJson,
  PreviewJsonProps,
} from '@cast/design-system';

import { CopyCode } from './CopyCode';

export const PreviewJson = ({
  actionsProps,
  ...props
}: PreviewJsonProps & { actionsProps?: Partial<CodeActionsProps> }) => {
  return (
    <DsPreviewJson {...props}>
      <CodeActions {...actionsProps}>
        <CopyCode />
      </CodeActions>
    </DsPreviewJson>
  );
};
